import { useIsMobile } from "../../utils/functions/useIsMobile";
import { IconProps } from "./IconProps";

export const GameArrowDownIcon = ({ className }: IconProps) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <svg
      className={className}
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.07658 9.53155C8.482 10.1561 7.518 10.1561 6.92342 9.53155L0.448989 2.7303C-0.510143 1.72275 0.169151 -1.42225e-06 1.52557 -1.06065e-06L14.4744 3.12194e-06C15.8308 3.48354e-06 16.5101 1.72275 15.551 2.7303L9.07658 9.53155Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      className={className}
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3954 15.3822C13.6247 16.2059 12.3753 16.2059 11.6046 15.3822L0.581935 3.60064C-0.661204 2.27191 0.219241 -1.56215e-07 1.97731 0L24.0227 1.95888e-06C25.7808 2.11509e-06 26.6612 2.27192 25.4181 3.60065L14.3954 15.3822Z"
        fill="white"
      />
    </svg>
  );
};
